<style scoped>

[contenteditable]:focus {
    outline: 0px solid transparent;
}

.tab-sheet {
    font-size: 10px;
    border-top: 0.5px solid #ccc;
    border-right: 0.5px solid #ccc;
    width: 100%;
    cursor: pointer;
}

.tab-sheet.active {
    border-top: 0;
}

.tab-sheet .text {
    padding: 5px 20px 5px 20px;
}

.bottom-nav {
    position: fixed;
    z-index: 10000;
    bottom: 0;
    left: 0;
    float: left;
    width: 100%;
    background-color: #fff;
}

.bottom-nav div {
    display: block;
    float: left;
    width: auto;
    cursor: pointer;
}

.spread-sheet {
    margin-bottom: 30px;
}

.active {
  color: #78CB5B;
}
.inactive {
  color: #fff000;
}
.fa.fa-circle:before {
  content: "\25C9";
  /*color: #000;*/
}
th {
  text-align: center;
}
td:nth-child(1) {
  text-align: center;
}
td:nth-child(3) {
  text-align: center;
}
td:nth-child(2) {
  padding-left: 40px;
}
.event-active {
  font-weight: bold;
  color: #78CB5B;
  text-transform: uppercase;
  letter-spacing: 1.2px;
}
</style>

<template>

<div style="height: 100%">
    <ul id="left-chart-nav">
        <li class="active">
            <a class="left-chart-nav-link" id="left-chart-nav-line" href="#chart-type-line">
                <div class="chart-icon"></div>
                <div class="chart-name">Line</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-bar" href="#chart-type-bar">
                <div class="chart-icon"></div>
                <div class="chart-name">Bar</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-pie" href="#chart-type-pie">
                <div class="chart-icon"></div>
                <div class="chart-name">Pie</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-scatter" href="#chart-type-scatter">
                <div class="chart-icon"></div>
                <div class="chart-name">Scatter</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-map" href="#chart-type-map">
                <div class="chart-icon"></div>
                <div class="chart-name">GEO/Map</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-candlestick" href="#chart-type-candlestick">
                <div class="chart-icon"></div>
                <div class="chart-name">Candlestick</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-radar" href="#chart-type-radar">
                <div class="chart-icon"></div>
                <div class="chart-name">Radar</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-boxplot" href="#chart-type-boxplot">
                <div class="chart-icon"></div>
                <div class="chart-name">Boxplot</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-heatmap" href="#chart-type-heatmap">
                <div class="chart-icon"></div>
                <div class="chart-name">Heatmap</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-graph" href="#chart-type-graph">
                <div class="chart-icon"></div>
                <div class="chart-name">Graph</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-lines" href="#chart-type-lines">
                <div class="chart-icon"></div>
                <div class="chart-name">Lines</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-tree" href="#chart-type-tree">
                <div class="chart-icon"></div>
                <div class="chart-name">Tree</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-treemap" href="#chart-type-treemap">
                <div class="chart-icon"></div>
                <div class="chart-name">Treemap</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-sunburst" href="#chart-type-sunburst">
                <div class="chart-icon"></div>
                <div class="chart-name">Sunburst</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-parallel" href="#chart-type-parallel">
                <div class="chart-icon"></div>
                <div class="chart-name">Parallel</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-sankey" href="#chart-type-sankey">
                <div class="chart-icon"></div>
                <div class="chart-name">Sankey</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-funnel" href="#chart-type-funnel">
                <div class="chart-icon"></div>
                <div class="chart-name">Funnel</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-gauge" href="#chart-type-gauge">
                <div class="chart-icon"></div>
                <div class="chart-name">Gauge</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-pictorialBar" href="#chart-type-pictorialBar">
                <div class="chart-icon"></div>
                <div class="chart-name">PictorialBar</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-themeRiver" href="#chart-type-themeRiver">
                <div class="chart-icon"></div>
                <div class="chart-name">ThemeRiver</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-calendar" href="#chart-type-calendar">
                <div class="chart-icon"></div>
                <div class="chart-name">Calendar</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-custom" href="#chart-type-custom">
                <div class="chart-icon"></div>
                <div class="chart-name">Custom</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-dataset" href="#chart-type-dataset">
                <div class="chart-icon"></div>
                <div class="chart-name">Dataset</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-dataZoom" href="#chart-type-dataZoom">
                <div class="chart-icon"></div>
                <div class="chart-name">DataZoom</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-drag" href="#chart-type-drag">
                <div class="chart-icon"></div>
                <div class="chart-name">Drag</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-rich" href="#chart-type-rich">
                <div class="chart-icon"></div>
                <div class="chart-name">Rich Text</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-globe" href="#chart-type-globe">
                <div class="chart-icon"></div>
                <div class="chart-name">3D Globe</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-bar3D" href="#chart-type-bar3D">
                <div class="chart-icon"></div>
                <div class="chart-name">3D Bar</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-scatter3D" href="#chart-type-scatter3D">
                <div class="chart-icon"></div>
                <div class="chart-name">3D Scatter</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-surface" href="#chart-type-surface">
                <div class="chart-icon"></div>
                <div class="chart-name">3D Surface</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-map3D" href="#chart-type-map3D">
                <div class="chart-icon"></div>
                <div class="chart-name">3D Map</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-lines3D" href="#chart-type-lines3D">
                <div class="chart-icon"></div>
                <div class="chart-name">3D Lines</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-line3D" href="#chart-type-line3D">
                <div class="chart-icon"></div>
                <div class="chart-name">3D Line</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-scatterGL" href="#chart-type-scatterGL">
                <div class="chart-icon"></div>
                <div class="chart-name">Scatter GL</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-linesGL" href="#chart-type-linesGL">
                <div class="chart-icon"></div>
                <div class="chart-name">Lines GL</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-flowGL" href="#chart-type-flowGL">
                <div class="chart-icon"></div>
                <div class="chart-name">Flow GL</div>
            </a>
        </li>
        <li>
            <a class="left-chart-nav-link" id="left-chart-nav-graphGL" href="#chart-type-graphGL">
                <div class="chart-icon"></div>
                <div class="chart-name">Graph GL</div>
            </a>
        </li>
    </ul>
    <v-container fluid fill-height class="spread-sheet">

        <v-layout class="mb-2" row wrap justify-start align-left text-xs-left>
            <vue-dropzone id="drop1" :options="dropOptions"></vue-dropzone>
            <dropdown-filter />
            <date-filter />
            <number />
            <v-flex xs12 sm12>
                <v-btn flat icon color="indigo">
                    <v-icon>refresh</v-icon>
                </v-btn>
                <v-btn flat icon color="indigo" v-on:click="aUpdate(chart)">
                    <v-icon>save</v-icon>
                </v-btn>
                <v-btn flat icon color="pink" v-on:click="aDelete(chart)">
                    <v-icon>delete</v-icon>
                </v-btn>
                <v-btn flat icon color="pink" v-on:click="mToggleEditable(editable)">
                    <v-icon>edit</v-icon>
                </v-btn>
            </v-flex>
            <v-flex xs12 sm3 fill-height>
                <v-card>
                    <!--<chart-parameters />-->
                </v-card>
            </v-flex>
            <v-flex xs12 sm9 fill-height>
                <v-card>
                    <text-chart />
                    <spark-line />
                    <!--<chart-scene />-->
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

    <div class="bottom-nav">
        <div v-for="item in charts" v-bind:key="item.id" class="text-xs-left tab-sheet" v-on:click="aSet(item)" v-bind:class="{ active: item.id === chart.id }">
            <div contenteditable="true" @blur="updateName" class="text">{{ item.name }}</div>
        </div>
        <div class="bottom-icon text-xs-center" v-on:click="aAdd()">
            <v-icon class="text-xs-center">add</v-icon>
        </div>
    </div>
</div>

</template>

<script>

import SpreadSheet from '@/components/data/SpreadSheet.vue';
import SQL from '@/components/data/SQL.vue';
import DataSource from '@/components/data/DataSource.vue';
import List from '@/components/data/List.vue';
import Preview from '@/components/data/Preview.vue';
import ChartParameters from '@/components/charts/Parameter.vue';
import ChartScene from '@/components/charts/Scene.vue';
import SparkLine from '@/components/charts/sparkline/default/chart.vue';
import TextChart from '@/components/charts/text/default/chart.vue';

import NumberChart from '@/components/charts/sparkline/number/chart.vue';

import DateFilterChart from '@/components/charts/filter/date/chart.vue';
import DropdownFilterChart from '@/components/charts/filter/dropdown/chart.vue';
import VueDropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import {
    createNamespacedHelpers
}
from 'vuex'
const {
    mapState, mapActions, mapGetters, mapMutations
} = createNamespacedHelpers('dataSources')

const dataSourceNamespace = createNamespacedHelpers('dataSources');
const chartNamespace = createNamespacedHelpers('charts');
import ApiService from "@/services/api.service";

export default {
    data: function() {
      let params = this.$route.params;
      let url = ApiService.getBaseUrl() + "/files/" + params.projectId + "/uploadFile";
        return {
            dropOptions: {
                url: url,
                headers: ApiService.getHeader(),
                maxFilesize: 200, // MB
                maxFiles: 10,
                acceptedFiles: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            }
        }
    },
    name: 'charts',
    components: {
        'chart-parameters': ChartParameters,
        'chart-scene': ChartScene,
        'spread-sheet': SpreadSheet,
        'sql': SQL,
        'data-source': DataSource,
        'list': List,
        'preview': Preview,
        'spark-line': SparkLine,
        'text-chart': TextChart,
        'date-filter': DateFilterChart,
        'dropdown-filter': DropdownFilterChart,
        'number': NumberChart,
        'vue-dropzone': VueDropzone
    },
    computed: {
        // ...dataSourceNamespace.mapState(['dataSources']),
        ...chartNamespace.mapState({
            //  dataSources: state => state.dataSources,
            charts: state => state.charts,
            chart: state => state.chart,
            editable: state => state.editable
                //   parameters: state => state.chart.parameters,
                //  chartTypes: state => state.chartTypes,
        })
    },
    methods: {
        ...chartNamespace.mapMutations(['mAdd', 'mSetProjectId', 'mSetTypeGroup', 'mSet', 'mSetName', 'mToggleEditable']),
            ...chartNamespace.mapActions(['aAdd', 'aInit', 'aUpdate', 'aSet', 'aDelete']),
            updateName: function(event) {
                this.mSetName(event.target.innerText);
            }
    },
    mounted: function() {
        // console.log("mounted");
        let params = this.$route.params;
        this.mSetProjectId(params.projectId);
        this.mSetTypeGroup("chart");
        this.aInit();


    },
    beforeCreate: function() {

    }
}

</script>
